import { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useRacesWithAwards from '../useRacesWithAwards.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';

const useAwardsLink = (): NavLinkProps | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event, lastSelectedRace }] = useApp();
  const { listingSettings, uniqueCode } = event || {};
  const racesWithAwards = useRacesWithAwards();
  const { search } = useLocation();
  const { isAwards } = useAppLocation();
  const derivedUrl = useMemo(
    () =>
      `/events/${uniqueCode}/race/${encodeURIComponent(String(racesWithAwards.find(({ id }) => `${id}` === lastSelectedRace)?.id ?? 'all'))}/awards${search}`,
    [uniqueCode, racesWithAwards, search, lastSelectedRace]
  );

  if (!event || !listingSettings?.hasAwards || racesWithAwards.length === 0) {
    return null;
  }

  return {
    id: 'awards',
    active: isAwards,
    children: (
      <Link
        to={derivedUrl}
        className={'flex items-center'}
        data-dd-action-name={'link-awards-nav_menu'}>
        <Trophy size={16} strokeWidth={2} className={'mr-4'} />
        {t('awards_label')}
      </Link>
    ),
  };
};

export default useAwardsLink;
